import { render, staticRenderFns } from "./cartaoVirtual.vue?vue&type=template&id=535d8e82&"
import script from "./cartaoVirtual.vue?vue&type=script&lang=js&"
export * from "./cartaoVirtual.vue?vue&type=script&lang=js&"
import style0 from "./cartaoVirtual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports